import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '@/contexts/AuthContext';
import Login from './Login';
var ProtectedRoute = function (_a) {
    var children = _a.children;
    var _b = useAuth(), isAuthenticated = _b.isAuthenticated, isLoading = _b.isLoading;
    if (isLoading) {
        return (_jsx(Box, { sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            }, children: _jsx(CircularProgress, { size: 60, sx: { color: 'white' } }) }));
    }
    if (!isAuthenticated) {
        return _jsx(Login, {});
    }
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
